export const PLAN_SAVING_OPTIONS = Object.freeze({
  AssignCustomer: 'AssignCustomer',
  Template: 'Template',
});

export type PlanSavingOption = typeof PLAN_SAVING_OPTIONS[keyof typeof PLAN_SAVING_OPTIONS];